<template>
    <card>
        <template v-slot:title>
            <slot name="title"></slot>
        </template>
        <div class="mb-6 lang-HE front">
            <slot name="front"></slot>
        </div>
        <hr/>
        <div class="mt-6 lang-AR front">
            <slot name="back"></slot>
        </div>
    </card>
</template>

<script>
    import CardFront from "@/components/CardFront";
    import Card from "@/components/Card";
    export default {
        name: "CardBack",
        components: {Card, CardFront}
    }
</script>

<style scoped>

</style>